export const FETCH_REALTIME_DATA = 'FETCH_REALTIME_DATA';
export const FETCH_REALTIME_DATA_SUCCESS = 'FETCH_REALTIME_DATA_SUCCESS';
export const FETCH_REALTIME_DATA_ERROR = 'FETCH_REALTIME_DATA_ERROR';

export const FETCH_SORTED_MACHINE_LIST = 'FETCH_SORTED_MACHINE_LIST';
export const FETCH_SORTED_MACHINE_LIST_SUCCESS =
  'FETCH_SORTED_MACHINE_LIST_SUCCESS';
export const FETCH_SORTED_MACHINE_LIST_ERROR =
  'FETCH_SORTED_MACHINE_LIST_ERROR';

export const ADD_MACHINES_TO_DISPLAY_LIST = 'ADD_MACHINES_TO_DISPLAY_LIST';
export const REMOVE_MACHINES_FROM_DISPLAY_LIST =
  'REMOVE_MACHINES_FROM_DISPLAY_LIST';
export const RESET_MACHINES_TO_DISPLAY_LIST = 'RESET_MACHINES_TO_DISPLAY_LIST';

export const FETCH_STOP_DATA_BY_SHIFT = 'FETCH_STOP_DATA_BY_SHIFT';
export const FETCH_STOP_DATA_BY_SHIFT_SUCCESS =
  'FETCH_STOP_DATA_BY_SHIFT_SUCCESS';
export const FETCH_STOP_DATA_BY_SHIFT_ERROR = 'FETCH_STOP_DATA_BY_SHIFT_ERROR';

export const EMPTY_MACHINE_DATA = 'EMPTY_MACHINE_DATA';

export const SET_SELECTED_SHIFT = 'SET_SELECTED_SHIFT';
export const LOAD_MACHINES_SORTING_FILTER = 'LOAD_MACHINES_SORTING_FILTER';
